function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { isEmpty } from 'lodash';
import { stringify } from 'utils/query-string';
import { HttpClient } from 'api/http-client';
import { InitWorkerApi, InitWorkerRequestType } from 'initWorker';
class RbacHttpClient extends HttpClient {
    constructor(...args){
        super(...args), _define_property(this, "getPermissionSetDefinitions", async (queryParams = {})=>{
            let data;
            if (isEmpty(queryParams)) {
                return this.get('/permission-set/get-definition');
            }
            const makeManualCall = async ()=>{
                return this.get(`/permission-set/get-definition?${stringify(queryParams)}`);
            };
            if (process.env.NODE_ENV === 'test') {
                data = await makeManualCall();
                return data;
            }
            try {
                data = await InitWorkerApi.getData(InitWorkerRequestType.PermissionSetDefinitions);
            } catch (unused) {
                data = await makeManualCall();
            }
            return data;
        }), _define_property(this, "getPermissionSetDefinitionsLight", async ()=>{
            return this.get('/permission-set/get-definition-light');
        }), _define_property(this, "createCustomPermissionSet", async (data)=>{
            return this.post('/permission-set/custom-permission-set', data);
        }), _define_property(this, "updatePermissionSet", async (data)=>this.put('/permission-set/custom-permission-set', data)), _define_property(this, "getEntityAccess", async (entityIds, pageSource)=>this.post('/permissions/entity-access', {
                entityIds,
                rbacPageSource: pageSource
            }));
    }
}
export const RbacApi = new RbacHttpClient();
